import { AuthorizedApiBase } from "./AuthorizedApiBase";
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class TicketsClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:7071/releases";
    }

    /**
     * @return Payload of Array of AgxTicket
     */
    getQualityAssuranceTickets(): Promise<AgxTicket[]> {
        let url_ = this.baseUrl + "/GetQualityAssuranceTickets";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQualityAssuranceTickets(_response);
        });
    }

    protected processGetQualityAssuranceTickets(response: Response): Promise<AgxTicket[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgxTicket.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgxTicket[]>(null as any);
    }

    /**
     * @return No description
     */
    heartbeat(): Promise<void> {
        let url_ = this.baseUrl + "/Heartbeat";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHeartbeat(_response);
        });
    }

    protected processHeartbeat(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AgxJiraInformation implements IAgxJiraInformation {
    jiraIssueKey?: string | undefined;
    description?: string | undefined;
    status?: AgxJiraInformationStatus | undefined;
    businessAnalysts?: PersonInvolved[] | undefined;
    developers?: PersonInvolved[] | undefined;
    testers?: PersonInvolved[] | undefined;

    constructor(data?: IAgxJiraInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.status = AgxJiraInformationStatus.DevelopmentRequired;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jiraIssueKey = _data["jiraIssueKey"];
            this.description = _data["description"];
            this.status = _data["status"] !== undefined ? _data["status"] : AgxJiraInformationStatus.DevelopmentRequired;
            if (Array.isArray(_data["businessAnalysts"])) {
                this.businessAnalysts = [] as any;
                for (let item of _data["businessAnalysts"])
                    this.businessAnalysts!.push(PersonInvolved.fromJS(item));
            }
            if (Array.isArray(_data["developers"])) {
                this.developers = [] as any;
                for (let item of _data["developers"])
                    this.developers!.push(PersonInvolved.fromJS(item));
            }
            if (Array.isArray(_data["testers"])) {
                this.testers = [] as any;
                for (let item of _data["testers"])
                    this.testers!.push(PersonInvolved.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgxJiraInformation {
        data = typeof data === 'object' ? data : {};
        let result = new AgxJiraInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jiraIssueKey"] = this.jiraIssueKey;
        data["description"] = this.description;
        data["status"] = this.status;
        if (Array.isArray(this.businessAnalysts)) {
            data["businessAnalysts"] = [];
            for (let item of this.businessAnalysts)
                data["businessAnalysts"].push(item.toJSON());
        }
        if (Array.isArray(this.developers)) {
            data["developers"] = [];
            for (let item of this.developers)
                data["developers"].push(item.toJSON());
        }
        if (Array.isArray(this.testers)) {
            data["testers"] = [];
            for (let item of this.testers)
                data["testers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgxJiraInformation {
    jiraIssueKey?: string | undefined;
    description?: string | undefined;
    status?: AgxJiraInformationStatus | undefined;
    businessAnalysts?: PersonInvolved[] | undefined;
    developers?: PersonInvolved[] | undefined;
    testers?: PersonInvolved[] | undefined;
}

export class AgxTicket implements IAgxTicket {
    agxJiraInformation?: AgxJiraInformation | undefined;
    serviceBuilds?: TicketServiceBuilds[] | undefined;
    ticketsWithIntersectingDeployments?: TicketWithIntersectingBuild[] | undefined;

    constructor(data?: IAgxTicket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agxJiraInformation = _data["agxJiraInformation"] ? AgxJiraInformation.fromJS(_data["agxJiraInformation"]) : <any>undefined;
            if (Array.isArray(_data["serviceBuilds"])) {
                this.serviceBuilds = [] as any;
                for (let item of _data["serviceBuilds"])
                    this.serviceBuilds!.push(TicketServiceBuilds.fromJS(item));
            }
            if (Array.isArray(_data["ticketsWithIntersectingDeployments"])) {
                this.ticketsWithIntersectingDeployments = [] as any;
                for (let item of _data["ticketsWithIntersectingDeployments"])
                    this.ticketsWithIntersectingDeployments!.push(TicketWithIntersectingBuild.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgxTicket {
        data = typeof data === 'object' ? data : {};
        let result = new AgxTicket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agxJiraInformation"] = this.agxJiraInformation ? this.agxJiraInformation.toJSON() : <any>undefined;
        if (Array.isArray(this.serviceBuilds)) {
            data["serviceBuilds"] = [];
            for (let item of this.serviceBuilds)
                data["serviceBuilds"].push(item.toJSON());
        }
        if (Array.isArray(this.ticketsWithIntersectingDeployments)) {
            data["ticketsWithIntersectingDeployments"] = [];
            for (let item of this.ticketsWithIntersectingDeployments)
                data["ticketsWithIntersectingDeployments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgxTicket {
    agxJiraInformation?: AgxJiraInformation | undefined;
    serviceBuilds?: TicketServiceBuilds[] | undefined;
    ticketsWithIntersectingDeployments?: TicketWithIntersectingBuild[] | undefined;
}

export class BuildVersion implements IBuildVersion {
    versionString?: string | undefined;

    constructor(data?: IBuildVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionString = _data["versionString"];
        }
    }

    static fromJS(data: any): BuildVersion {
        data = typeof data === 'object' ? data : {};
        let result = new BuildVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionString"] = this.versionString;
        return data;
    }
}

export interface IBuildVersion {
    versionString?: string | undefined;
}

export class EnvironmentDeployments implements IEnvironmentDeployments {
    development?: BuildVersion | undefined;
    staging?: BuildVersion | undefined;
    userAcceptingTesting?: BuildVersion | undefined;
    demo?: BuildVersion | undefined;
    production?: BuildVersion | undefined;

    constructor(data?: IEnvironmentDeployments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.development = _data["development"] ? BuildVersion.fromJS(_data["development"]) : <any>undefined;
            this.staging = _data["staging"] ? BuildVersion.fromJS(_data["staging"]) : <any>undefined;
            this.userAcceptingTesting = _data["userAcceptingTesting"] ? BuildVersion.fromJS(_data["userAcceptingTesting"]) : <any>undefined;
            this.demo = _data["demo"] ? BuildVersion.fromJS(_data["demo"]) : <any>undefined;
            this.production = _data["production"] ? BuildVersion.fromJS(_data["production"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EnvironmentDeployments {
        data = typeof data === 'object' ? data : {};
        let result = new EnvironmentDeployments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["development"] = this.development ? this.development.toJSON() : <any>undefined;
        data["staging"] = this.staging ? this.staging.toJSON() : <any>undefined;
        data["userAcceptingTesting"] = this.userAcceptingTesting ? this.userAcceptingTesting.toJSON() : <any>undefined;
        data["demo"] = this.demo ? this.demo.toJSON() : <any>undefined;
        data["production"] = this.production ? this.production.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEnvironmentDeployments {
    development?: BuildVersion | undefined;
    staging?: BuildVersion | undefined;
    userAcceptingTesting?: BuildVersion | undefined;
    demo?: BuildVersion | undefined;
    production?: BuildVersion | undefined;
}

export class PersonInvolved implements IPersonInvolved {
    email?: string | undefined;
    name?: string | undefined;
    avatarUrl?: string | undefined;

    constructor(data?: IPersonInvolved) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.name = _data["name"];
            this.avatarUrl = _data["avatarUrl"];
        }
    }

    static fromJS(data: any): PersonInvolved {
        data = typeof data === 'object' ? data : {};
        let result = new PersonInvolved();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["name"] = this.name;
        data["avatarUrl"] = this.avatarUrl;
        return data;
    }
}

export interface IPersonInvolved {
    email?: string | undefined;
    name?: string | undefined;
    avatarUrl?: string | undefined;
}

export class ServiceIntersectingBuild implements IServiceIntersectingBuild {
    service?: ServiceIntersectingBuildService | undefined;
    buildVersions?: BuildVersion[] | undefined;

    constructor(data?: IServiceIntersectingBuild) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.service = ServiceIntersectingBuildService.Agencies;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.service = _data["service"] !== undefined ? _data["service"] : ServiceIntersectingBuildService.Agencies;
            if (Array.isArray(_data["buildVersions"])) {
                this.buildVersions = [] as any;
                for (let item of _data["buildVersions"])
                    this.buildVersions!.push(BuildVersion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceIntersectingBuild {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceIntersectingBuild();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service;
        if (Array.isArray(this.buildVersions)) {
            data["buildVersions"] = [];
            for (let item of this.buildVersions)
                data["buildVersions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IServiceIntersectingBuild {
    service?: ServiceIntersectingBuildService | undefined;
    buildVersions?: BuildVersion[] | undefined;
}

export class TicketServiceBuilds implements ITicketServiceBuilds {
    service?: TicketServiceBuildsService | undefined;
    latestPullRequestUri?: string | undefined;
    builds?: BuildVersion[] | undefined;
    latestDeploymentsForTicket?: EnvironmentDeployments | undefined;

    constructor(data?: ITicketServiceBuilds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.service = TicketServiceBuildsService.Agencies;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.service = _data["service"] !== undefined ? _data["service"] : TicketServiceBuildsService.Agencies;
            this.latestPullRequestUri = _data["latestPullRequestUri"];
            if (Array.isArray(_data["builds"])) {
                this.builds = [] as any;
                for (let item of _data["builds"])
                    this.builds!.push(BuildVersion.fromJS(item));
            }
            this.latestDeploymentsForTicket = _data["latestDeploymentsForTicket"] ? EnvironmentDeployments.fromJS(_data["latestDeploymentsForTicket"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TicketServiceBuilds {
        data = typeof data === 'object' ? data : {};
        let result = new TicketServiceBuilds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service;
        data["latestPullRequestUri"] = this.latestPullRequestUri;
        if (Array.isArray(this.builds)) {
            data["builds"] = [];
            for (let item of this.builds)
                data["builds"].push(item.toJSON());
        }
        data["latestDeploymentsForTicket"] = this.latestDeploymentsForTicket ? this.latestDeploymentsForTicket.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITicketServiceBuilds {
    service?: TicketServiceBuildsService | undefined;
    latestPullRequestUri?: string | undefined;
    builds?: BuildVersion[] | undefined;
    latestDeploymentsForTicket?: EnvironmentDeployments | undefined;
}

export class TicketWithIntersectingBuild implements ITicketWithIntersectingBuild {
    key?: string | undefined;
    description?: string | undefined;
    status?: TicketWithIntersectingBuildStatus | undefined;
    servicesIntersectingBuilds?: ServiceIntersectingBuild[] | undefined;

    constructor(data?: ITicketWithIntersectingBuild) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.status = TicketWithIntersectingBuildStatus.DevelopmentRequired;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.description = _data["description"];
            this.status = _data["status"] !== undefined ? _data["status"] : TicketWithIntersectingBuildStatus.DevelopmentRequired;
            if (Array.isArray(_data["servicesIntersectingBuilds"])) {
                this.servicesIntersectingBuilds = [] as any;
                for (let item of _data["servicesIntersectingBuilds"])
                    this.servicesIntersectingBuilds!.push(ServiceIntersectingBuild.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketWithIntersectingBuild {
        data = typeof data === 'object' ? data : {};
        let result = new TicketWithIntersectingBuild();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["description"] = this.description;
        data["status"] = this.status;
        if (Array.isArray(this.servicesIntersectingBuilds)) {
            data["servicesIntersectingBuilds"] = [];
            for (let item of this.servicesIntersectingBuilds)
                data["servicesIntersectingBuilds"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITicketWithIntersectingBuild {
    key?: string | undefined;
    description?: string | undefined;
    status?: TicketWithIntersectingBuildStatus | undefined;
    servicesIntersectingBuilds?: ServiceIntersectingBuild[] | undefined;
}

export enum AgxJiraInformationStatus {
    DevelopmentRequired = "DevelopmentRequired",
    OnHold = "OnHold",
    InProgress = "InProgress",
    ReadyForTesting = "ReadyForTesting",
    Testing = "Testing",
    ReadyForRelease = "ReadyForRelease",
    ReadyForUAT = "ReadyForUAT",
    UserAcceptanceTesting = "UserAcceptanceTesting",
    Done = "Done",
}

export enum ServiceIntersectingBuildService {
    Agencies = "Agencies",
    Auth = "Auth",
    CampaignFlow = "CampaignFlow",
    Campaigns = "Campaigns",
    DeadLetters = "DeadLetters",
    Docusign = "Docusign",
    Domain = "Domain",
    Marketing = "Marketing",
    Migrator = "Migrator",
    Notifications = "Notifications",
    Pdf = "Pdf",
    Pools = "Pools",
    Realestate = "Realestate",
    Rex = "Rex",
    Rpdata = "Rpdata",
    Staff = "Staff",
    TitleSearch = "TitleSearch",
    AgentPortal = "AgentPortal",
    StaffPortal = "StaffPortal",
    ApplicationTemplates = "ApplicationTemplates",
    Events = "Events",
    Db = "Db",
    UIComponents = "UIComponents",
    Forms = "Forms",
    Core = "Core",
}

export enum TicketServiceBuildsService {
    Agencies = "Agencies",
    Auth = "Auth",
    CampaignFlow = "CampaignFlow",
    Campaigns = "Campaigns",
    DeadLetters = "DeadLetters",
    Docusign = "Docusign",
    Domain = "Domain",
    Marketing = "Marketing",
    Migrator = "Migrator",
    Notifications = "Notifications",
    Pdf = "Pdf",
    Pools = "Pools",
    Realestate = "Realestate",
    Rex = "Rex",
    Rpdata = "Rpdata",
    Staff = "Staff",
    TitleSearch = "TitleSearch",
    AgentPortal = "AgentPortal",
    StaffPortal = "StaffPortal",
    ApplicationTemplates = "ApplicationTemplates",
    Events = "Events",
    Db = "Db",
    UIComponents = "UIComponents",
    Forms = "Forms",
    Core = "Core",
}

export enum TicketWithIntersectingBuildStatus {
    DevelopmentRequired = "DevelopmentRequired",
    OnHold = "OnHold",
    InProgress = "InProgress",
    ReadyForTesting = "ReadyForTesting",
    Testing = "Testing",
    ReadyForRelease = "ReadyForRelease",
    ReadyForUAT = "ReadyForUAT",
    UserAcceptanceTesting = "UserAcceptanceTesting",
    Done = "Done",
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}